/**
 * Simple marquee for preview pages – no external dependency.
 * API compatible with react-fast-marquee (direction, speed, pauseOnHover, children, className).
 */

import React, { useState } from "react";

interface MarqueeProps {
  children: React.ReactNode;
  direction?: "left" | "right";
  speed?: number;
  pauseOnHover?: boolean;
  className?: string;
}

export default function Marquee({
  children,
  direction = "left",
  speed = 50,
  pauseOnHover = false,
  className = "",
}: MarqueeProps) {
  const [paused, setPaused] = useState(false);
  const duration = Math.max(10, 100 - speed);
  const playState = pauseOnHover && paused ? "paused" : "running";

  return (
    <div
      className={`overflow-hidden whitespace-nowrap ${className}`}
      onMouseEnter={() => pauseOnHover && setPaused(true)}
      onMouseLeave={() => pauseOnHover && setPaused(false)}
    >
      <div
        className="inline-flex"
        style={{
          animation: `marquee-${direction} ${duration}s linear infinite`,
          animationPlayState: playState,
        }}
      >
        <span className="inline-block pr-[2em]">{children}</span>
        <span className="inline-block pr-[2em]">{children}</span>
      </div>
      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}
